var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeliveryCancelled = function SvgDeliveryCancelled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "inherit",
    d: "M1 6.5a5.5 5.5 0 1 0 11 0 5.5 5.5 0 0 0-11 0M14 11h1.5a1.5 1.5 0 0 1 1.5 1.5V17M6.5 19.5A1.5 1.5 0 0 1 5 18v-3M15 20a2 2 0 1 0 4 0 2 2 0 0 0-4 0M7 20a2 2 0 1 0 4 0 2 2 0 0 0-4 0M15 20h-3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "inherit",
    d: "M17 13h2.615a2.41 2.41 0 0 1 2.41 2.41V20H19M8 5 5 8M5 5l3 3"
  })));
};
export default SvgDeliveryCancelled;